"use client";

import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "@/components/ui/toaster";

import CustomSnackbarProvider from "@/components/widgets/notification/Notification";

import { persistor, store } from "./store";

const queryClient = new QueryClient();

export function ReduxProvider({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <CustomSnackbarProvider>
            {children}
            <Toaster />
          </CustomSnackbarProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}
